import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import TMELogsMobile from "./TMELogsMobile";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { delete_trainer_member_engagement_form_submit } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  formatTimezoneThenStraight,
} from "../common-data/Converts";
import CheckedinMembersMobile from "./CheckedinMembersMobile";
import CommonTable from "../common-components/common-tables/CommonTable";
import {
  BinIcon1,
  CalendarIcon,
  CallIcon,
  CheckCircleIcon,
  ClockIconV3,
  EditIcon1,
  EmailIcon,
  ExcludeIcon,
  PersonIcon,
  XCircleIcon,
} from "../../images/icons/icons";
import TMEAnalysis from "./tme-analysis/TMEAnalysis";
import useTableSorting from "../../hooks/useTableSorting";
import SortableHeader from "../common-components/SortableHeader";
import { isManagerRole } from "../common-data/Conversions";

const TMEtabs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  tableRef,
  mobileTableRef,
  selectedTab,
  handleTabSelect,
  userInfoData,
  setClickValues,
  callFunction,
  allFilters,
}) => {
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.delApi);
  const {
    tmeLoading,
    trainer_member_engagement,
    tmeActiveUsers,
    tmeActiveUsersLoading,
    tmeActiveUsersError,
    tmeExpiredMembers,
    tmeExpiredMembersLoading,
    tmeExpiredMembersError,
  } = useSelector((state) => state.api);
  const { checkedInMembersLoading, checkedInMembers } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isTrainerMapAllowed =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "receptionist" ||
    isManagerRole(userInfoData);

  const iniDatas = {
    pagination: [],
    allSubmissions: [],
    allCheckedInMembers: [],
    allCheckedInMembersPagination: [],
    allActiveUsers: [],
    allActiveUsersPagination: [],
    allExpiredMembers: [],
    allExpiredMembersPagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const tmeSorting = useTableSorting(allDatas.allSubmissions || []);
  const nonTMESorting = useTableSorting(allDatas.allCheckedInMembers || []);
  const activeMembersSorting = useTableSorting(allDatas.allActiveUsers || []);
  const expiredMembersSorting = useTableSorting(
    allDatas.allExpiredMembers || []
  );

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_trainer_member_engagement_form_submit,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            callFunction();
            toast.success(
              response?.message || "Feature is deleted successfully!"
            );
          } else {
            toast.error(response?.message || "Can not delete Feature!");
          }
        } catch (error) {
          toast.error(error || "Deleted SuccessFully");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (trainer_member_engagement?.status && trainer_member_engagement?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        allSubmissions: trainer_member_engagement.data,
        pagination:
          trainer_member_engagement?.pagination?.length > 0
            ? trainer_member_engagement.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allSubmissions: [],
        pagination: [],
      }));
    }
  }, [trainer_member_engagement]);

  useEffect(() => {
    if (checkedInMembers?.status && checkedInMembers?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        allCheckedInMembers: checkedInMembers.data,
        allCheckedInMembersPagination:
          checkedInMembers?.pagination?.length > 0
            ? checkedInMembers.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allCheckedInMembers: [],
        allCheckedInMembersPagination: [],
      }));
    }
  }, [checkedInMembers]);

  useEffect(() => {
    if (
      !tmeActiveUsersLoading &&
      !tmeActiveUsersError &&
      tmeActiveUsers?.status &&
      tmeActiveUsers?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allActiveUsers: tmeActiveUsers.data,
        allActiveUsersPagination:
          tmeActiveUsers?.pagination?.length > 0
            ? tmeActiveUsers.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allActiveUsers: [],
        allActiveUsersPagination: [],
      }));
    }
  }, [tmeActiveUsersLoading, tmeActiveUsersError, tmeActiveUsers]);

  useEffect(() => {
    if (
      !tmeExpiredMembersLoading &&
      !tmeExpiredMembersError &&
      tmeExpiredMembers?.status &&
      tmeExpiredMembers?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allExpiredMembers: tmeExpiredMembers.data,
        allExpiredMembersPagination:
          tmeExpiredMembers?.pagination?.length > 0
            ? tmeExpiredMembers.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allExpiredMembers: [],
        allExpiredMembersPagination: [],
      }));
    }
  }, [tmeExpiredMembersLoading, tmeExpiredMembersError, tmeExpiredMembers]);

  const tmeTbColumns = [
    {
      dataField: "date_added",
      text: (
        <SortableHeader
          text="TME Add date"
          field="date_added"
          onSort={tmeSorting.handleSort}
          sortDirection={tmeSorting.getSortDirection("date_added")}
          isSorted={tmeSorting.isFieldSorted("date_added")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 />
            </span>{" "}
            <span className="tb-data">
              {row?.date_added
                ? formatTimezoneThenStraight(row.date_added)
                : "-"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_view_details",
                  rowData: row,
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.user_name || row?.name || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_mobile || row?.mobile || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span
                className={`tb-data lowercase ${
                  isEmailLong ? "tb-data-long" : ""
                }`}
              >
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer info",
      formatter: (_, row) => {
        const email = row?.trainer_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <>
            {row?.trainer_id ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <EmailIcon />
                  </span>{" "}
                  <span
                    className={`tb-data lowercase ${
                      isEmailLong ? "tb-data-long" : ""
                    }`}
                  >
                    {row?.trainer_email || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: (
        <SortableHeader
          text="member last checkin"
          field="last_checkin"
          onSort={tmeSorting.handleSort}
          sortDirection={tmeSorting.getSortDirection("last_checkin")}
          isSorted={tmeSorting.isFieldSorted("last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                cardName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: (
        <SortableHeader
          text="trainer last checkin"
          field="trainer_last_checkin"
          onSort={tmeSorting.handleSort}
          sortDirection={tmeSorting.getSortDirection("trainer_last_checkin")}
          isSorted={tmeSorting.isFieldSorted("trainer_last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.trainer_id,
                isModOpen: true,
                cardName: "trainer_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.trainer_last_checkin || ""
                }&end_date=${row?.trainer_last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.trainer_last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.trainer_checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.trainer_last_checkin_days_ago
                ? row.trainer_last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "last_workout_date",
      text: (
        <SortableHeader
          text="member last workout"
          field="last_workout_date"
          onSort={tmeSorting.handleSort}
          sortDirection={tmeSorting.getSortDirection("last_workout_date")}
          isSorted={tmeSorting.isFieldSorted("last_workout_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_workout_details",
                  sendableStatsQPs: `&date_from=${
                    row?.last_checkin || ""
                  }&date_to=${row?.last_checkin || ""}`,
                  workoutDate: row?.last_workout_date
                    ? convertStraight(row.last_workout_date)
                    : "",
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_date
                  ? convertStraight(row.last_workout_date)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_status?.replace(/_/g, " ") || ""}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "current_trainer_avg_rating",
      text: "current trainer rating",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.current_trainer_avg_rating ? "tb-link" : "tb-icon"
            }`}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "trainer_rating_logs",
                rowData: row,
              }))
            }
          >
            {row?.current_trainer_avg_rating ? (
              row.current_trainer_avg_rating
            ) : (
              <XCircleIcon />
            )}
            {row?.current_trainer_avg_rating && "★"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "regular plan status",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data tb-badge ${
                row?.current_plan_status === "active"
                  ? "tb-badge-success"
                  : "not-assigned"
              }`}
            >
              {row?.current_plan_status || "NA"}
            </span>
            <div className="tb-flex">
              <span
                className={`tb-data tb-badge ${
                  row?.subscription_expiry_days === "active"
                    ? "tb-badge-success"
                    : "tb-badge-stuck"
                }`}
              >
                {row?.subscription_expiry_days || "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "bca_status",
      text: "Current BCA Status",
      formatter: (_, row) => {
        const isFirstBCA = row?.bca_report;

        return (
          <span
            className={`tb-data ${isFirstBCA ? "tb-link" : ""}`}
            onClick={() =>
              isFirstBCA &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "bca_report",
              }))
            }
          >
            {!isFirstBCA
              ? "First BCA Not Done"
              : row?.current_bca_status || "view"}
          </span>
        );
      },
    },
    {
      dataField: "free_pt_consultation",
      text: "interested for PT trial",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.free_pt_consultation ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "trainer_status",
      text: "fitness profile",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-icon"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "fitness_profile_logs",
                rowData: row,
              }))
            }
          >
            {row?.fitness_profile !== "pending" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "consultation_data",
      text: "consultation data",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "consultation_data",
              }))
            }
          >
            view
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            {isTrainerMapAllowed && (
              <button
                key="map-trainer"
                type="button"
                className="pp-employee-payroll-action-button pp-outlined-border"
                onClick={() =>
                  setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    rowData: row,
                    cardName: "member_map",
                  }))
                }
              >
                <ExcludeIcon />
                map trainer
              </button>
            )}

            <button
              key="edit"
              type="button"
              className={`pp-employee-payroll-action-button pp-outlined-border ${
                loading ? "disabled" : ""
              }`}
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  editInfo: {
                    user_id: row?.trainer_id,
                    name: row?.trainer_name,
                    email: row?.trainer_email,
                    mobile: row?.trainer_mobile,
                    token: userInfoData?.token,
                    gym_id: row?.gym_id,
                    gym_name: row?.gym_name,
                    account_type: "trainer",
                  },
                  cardName: "edit",
                }))
              }
            >
              <EditIcon1 />
              edit
            </button>

            {isAdmin && (
              <button
                key="delete"
                type="button"
                className={`pp-employee-payroll-action-button pp-outlined-border ${
                  loading ? "disabled" : ""
                }`}
                onClick={() => {
                  const payload = {
                    uid: row?.uid,
                  };
                  handleDelete(payload);
                }}
              >
                <BinIcon1 />
                delete
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const nonTMETbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_view_details",
                  rowData: row,
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.user_name || row?.name || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_mobile || row?.mobile || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span
                className={`tb-data lowercase ${
                  isEmailLong ? "tb-data-long" : ""
                }`}
              >
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer info",
      formatter: (_, row) => {
        const email = row?.trainer_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <>
            {row?.trainer_id ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <EmailIcon />
                  </span>{" "}
                  <span
                    className={`tb-data lowercase ${
                      isEmailLong ? "tb-data-long" : ""
                    }`}
                  >
                    {row?.trainer_email || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "trainer_status",
      text: "trainer status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.trainer_status ? "tb-badge" : "tb-icon"
            }  ${
              row?.trainer_status === "active"
                ? "tb-badge-success"
                : row?.trainer_status
                ? "not-assigned"
                : ""
            }`}
          >
            {row?.trainer_status || <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: (
        <SortableHeader
          text="member last checkin"
          field="last_checkin"
          onSort={nonTMESorting.handleSort}
          sortDirection={nonTMESorting.getSortDirection("last_checkin")}
          isSorted={nonTMESorting.isFieldSorted("last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                cardName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: (
        <SortableHeader
          text="trainer last checkin"
          field="trainer_last_checkin"
          onSort={nonTMESorting.handleSort}
          sortDirection={nonTMESorting.getSortDirection("trainer_last_checkin")}
          isSorted={nonTMESorting.isFieldSorted("trainer_last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.trainer_id,
                isModOpen: true,
                cardName: "trainer_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.trainer_last_checkin || ""
                }&end_date=${row?.trainer_last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.trainer_last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.trainer_checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.trainer_last_checkin_days_ago
                ? row.trainer_last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "last_workout_date",
      text: (
        <SortableHeader
          text="member last workout"
          field="last_workout_date"
          onSort={nonTMESorting.handleSort}
          sortDirection={nonTMESorting.getSortDirection("last_workout_date")}
          isSorted={nonTMESorting.isFieldSorted("last_workout_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_workout_details",
                  sendableStatsQPs: `&date_from=${
                    row?.last_checkin || ""
                  }&date_to=${row?.last_checkin || ""}`,
                  workoutDate: row?.last_workout_date
                    ? convertStraight(row.last_workout_date)
                    : "",
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_date
                  ? convertStraight(row.last_workout_date)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_status?.replace(/_/g, " ") || ""}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "current_trainer_avg_rating",
      text: (
        <SortableHeader
          text="current trainer rating"
          field="current_trainer_avg_rating"
          onSort={nonTMESorting.handleSort}
          sortDirection={nonTMESorting.getSortDirection(
            "current_trainer_avg_rating"
          )}
          isSorted={nonTMESorting.isFieldSorted("current_trainer_avg_rating")}
        />
      ),
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.current_trainer_avg_rating ? "tb-link" : "tb-icon"
            }`}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "trainer_rating_logs",
                rowData: row,
              }))
            }
          >
            {row?.current_trainer_avg_rating ? (
              row.current_trainer_avg_rating
            ) : (
              <XCircleIcon />
            )}
            {row?.current_trainer_avg_rating && "★"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "regular plan status",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data tb-badge ${
                row?.current_plan_status === "active"
                  ? "tb-badge-success"
                  : "not-assigned"
              }`}
            >
              {row?.current_plan_status || "NA"}
            </span>
            <div className="tb-flex">
              <span
                className={`tb-data tb-badge ${
                  row?.subscription_expiry_days === "active"
                    ? "tb-badge-success"
                    : "tb-badge-stuck"
                }`}
              >
                {row?.subscription_expiry_days || "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "bca_status",
      text: "Current BCA Status",
      formatter: (_, row) => {
        const isFirstBCA = row?.bca_report;

        return (
          <span
            className={`tb-data ${isFirstBCA ? "tb-link" : ""}`}
            onClick={() =>
              isFirstBCA &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "bca_report",
              }))
            }
          >
            {!isFirstBCA
              ? "First BCA Not Done"
              : row?.current_bca_status || "view"}
          </span>
        );
      },
    },
    isTrainerMapAllowed && {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="map-trainer"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "member_map",
                }))
              }
            >
              <ExcludeIcon />
              map trainer
            </button>
          </div>
        );
      },
    },
  ];

  const activeMembersTbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_view_details",
                  rowData: row,
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.user_name || row?.name || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_mobile || row?.mobile || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span
                className={`tb-data lowercase ${
                  isEmailLong ? "tb-data-long" : ""
                }`}
              >
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer info",
      formatter: (_, row) => {
        const email = row?.trainer_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <>
            {row?.trainer_id ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <EmailIcon />
                  </span>{" "}
                  <span
                    className={`tb-data lowercase ${
                      isEmailLong ? "tb-data-long" : ""
                    }`}
                  >
                    {row?.trainer_email || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "trainer_status",
      text: "trainer status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.trainer_status ? "tb-badge" : "tb-icon"
            }  ${
              row?.trainer_status === "active"
                ? "tb-badge-success"
                : row?.trainer_status
                ? "not-assigned"
                : ""
            }`}
          >
            {row?.trainer_status || <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: (
        <SortableHeader
          text="member last checkin"
          field="last_checkin"
          onSort={activeMembersSorting.handleSort}
          sortDirection={activeMembersSorting.getSortDirection("last_checkin")}
          isSorted={activeMembersSorting.isFieldSorted("last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                cardName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: (
        <SortableHeader
          text="trainer last checkin"
          field="trainer_last_checkin"
          onSort={activeMembersSorting.handleSort}
          sortDirection={activeMembersSorting.getSortDirection(
            "trainer_last_checkin"
          )}
          isSorted={activeMembersSorting.isFieldSorted("trainer_last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.trainer_id,
                isModOpen: true,
                cardName: "trainer_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.trainer_last_checkin || ""
                }&end_date=${row?.trainer_last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.trainer_last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.trainer_checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.trainer_last_checkin_days_ago
                ? row.trainer_last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "last_workout_date",
      text: (
        <SortableHeader
          text="member last workout"
          field="last_workout_date"
          onSort={activeMembersSorting.handleSort}
          sortDirection={activeMembersSorting.getSortDirection(
            "last_workout_date"
          )}
          isSorted={activeMembersSorting.isFieldSorted("last_workout_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_workout_details",
                  sendableStatsQPs: `&date_from=${
                    row?.last_checkin || ""
                  }&date_to=${row?.last_checkin || ""}`,
                  workoutDate: row?.last_workout_date
                    ? convertStraight(row.last_workout_date)
                    : "",
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_date
                  ? convertStraight(row.last_workout_date)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_status?.replace(/_/g, " ") || ""}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "current_trainer_avg_rating",
      text: (
        <SortableHeader
          text="current trainer rating"
          field="current_trainer_avg_rating"
          onSort={activeMembersSorting.handleSort}
          sortDirection={activeMembersSorting.getSortDirection(
            "current_trainer_avg_rating"
          )}
          isSorted={activeMembersSorting.isFieldSorted(
            "current_trainer_avg_rating"
          )}
        />
      ),
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.current_trainer_avg_rating ? "tb-link" : "tb-icon"
            }`}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "trainer_rating_logs",
                rowData: row,
              }))
            }
          >
            {row?.current_trainer_avg_rating ? (
              row.current_trainer_avg_rating
            ) : (
              <XCircleIcon />
            )}
            {row?.current_trainer_avg_rating && "★"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "regular plan status",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data tb-badge ${
                row?.current_plan_status === "active"
                  ? "tb-badge-success"
                  : "not-assigned"
              }`}
            >
              {row?.current_plan_status || "NA"}
            </span>
            <div className="tb-flex">
              <span
                className={`tb-data tb-badge ${
                  row?.subscription_expiry_days === "active"
                    ? "tb-badge-success"
                    : "tb-badge-stuck"
                }`}
              >
                {row?.subscription_expiry_days || "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "bca_status",
      text: "Current BCA Status",
      formatter: (_, row) => {
        const isFirstBCA = row?.bca_report;

        return (
          <span
            className={`tb-data ${isFirstBCA ? "tb-link" : ""}`}
            onClick={() =>
              isFirstBCA &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "bca_report",
              }))
            }
          >
            {!isFirstBCA
              ? "First BCA Not Done"
              : row?.current_bca_status || "view"}
          </span>
        );
      },
    },
    isTrainerMapAllowed && {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="map-trainer"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "member_map",
                }))
              }
            >
              <ExcludeIcon />
              map trainer
            </button>
          </div>
        );
      },
    },
  ];

  const expiredMembersTbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        const email = row?.user_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_view_details",
                  rowData: row,
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.user_name || row?.name || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.user_mobile || row?.mobile || "NA"}
              </span>{" "}
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span
                className={`tb-data lowercase ${
                  isEmailLong ? "tb-data-long" : ""
                }`}
              >
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer info",
      formatter: (_, row) => {
        const email = row?.trainer_email || null;
        const isEmailLong = email?.length > 24;

        return (
          <>
            {row?.trainer_id ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <EmailIcon />
                  </span>{" "}
                  <span
                    className={`tb-data lowercase ${
                      isEmailLong ? "tb-data-long" : ""
                    }`}
                  >
                    {row?.trainer_email || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "trainer_status",
      text: "trainer status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.trainer_status ? "tb-badge" : "tb-icon"
            }  ${
              row?.trainer_status === "active"
                ? "tb-badge-success"
                : row?.trainer_status
                ? "not-assigned"
                : ""
            }`}
          >
            {row?.trainer_status || <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: (
        <SortableHeader
          text="member last checkin"
          field="last_checkin"
          onSort={expiredMembersSorting.handleSort}
          sortDirection={expiredMembersSorting.getSortDirection("last_checkin")}
          isSorted={expiredMembersSorting.isFieldSorted("last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                cardName: "member_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: (
        <SortableHeader
          text="trainer last checkin"
          field="trainer_last_checkin"
          onSort={expiredMembersSorting.handleSort}
          sortDirection={expiredMembersSorting.getSortDirection(
            "trainer_last_checkin"
          )}
          isSorted={expiredMembersSorting.isFieldSorted("trainer_last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div
            className="tb-flex-col"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.trainer_id,
                isModOpen: true,
                cardName: "trainer_checkin_details",
                sendableStatsQPs: `&start_date=${
                  row?.trainer_last_checkin || ""
                }&end_date=${row?.trainer_last_checkin || ""}`,
              }))
            }
          >
            <span className="tb-data tb-link">
              {convertStraight(row?.trainer_last_checkin) || "-"}{" "}
              {convertTimeRangeHHMMSS(row?.trainer_checkin_time) || ""}
            </span>
            <span className="tb-data tb-link">
              {row?.trainer_last_checkin_days_ago
                ? row.trainer_last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "last_workout_date",
      text: (
        <SortableHeader
          text="member last workout"
          field="last_workout_date"
          onSort={expiredMembersSorting.handleSort}
          sortDirection={expiredMembersSorting.getSortDirection(
            "last_workout_date"
          )}
          isSorted={expiredMembersSorting.isFieldSorted("last_workout_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  isModOpen: true,
                  cardName: "member_workout_details",
                  sendableStatsQPs: `&date_from=${
                    row?.last_checkin || ""
                  }&date_to=${row?.last_checkin || ""}`,
                  workoutDate: row?.last_workout_date
                    ? convertStraight(row.last_workout_date)
                    : "",
                }))
              }
            >
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon color="#2c3e50" />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_date
                  ? convertStraight(row.last_workout_date)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon tb-link">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data tb-link">
                {row?.last_workout_status?.replace(/_/g, " ") || ""}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "current_trainer_avg_rating",
      text: (
        <SortableHeader
          text="current trainer rating"
          field="current_trainer_avg_rating"
          onSort={expiredMembersSorting.handleSort}
          sortDirection={expiredMembersSorting.getSortDirection(
            "current_trainer_avg_rating"
          )}
          isSorted={expiredMembersSorting.isFieldSorted(
            "current_trainer_avg_rating"
          )}
        />
      ),
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.current_trainer_avg_rating ? "tb-link" : "tb-icon"
            }`}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "trainer_rating_logs",
                rowData: row,
              }))
            }
          >
            {row?.current_trainer_avg_rating ? (
              row.current_trainer_avg_rating
            ) : (
              <XCircleIcon />
            )}
            {row?.current_trainer_avg_rating && "★"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "regular plan status",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data tb-badge ${
                row?.current_plan_status === "active"
                  ? "tb-badge-success"
                  : "not-assigned"
              }`}
            >
              {row?.current_plan_status || "NA"}
            </span>
            <div className="tb-flex">
              <span
                className={`tb-data tb-badge ${
                  row?.subscription_expiry_days === "active"
                    ? "tb-badge-success"
                    : "tb-badge-stuck"
                }`}
              >
                {row?.subscription_expiry_days || "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "bca_status",
      text: "Current BCA Status",
      formatter: (_, row) => {
        const isFirstBCA = row?.bca_report;

        return (
          <span
            className={`tb-data ${isFirstBCA ? "tb-link" : ""}`}
            onClick={() =>
              isFirstBCA &&
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "bca_report",
              }))
            }
          >
            {!isFirstBCA
              ? "First BCA Not Done"
              : row?.current_bca_status || "view"}
          </span>
        );
      },
    },
    isTrainerMapAllowed && {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="map-trainer"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  cardName: "member_map",
                }))
              }
            >
              <ExcludeIcon />
              map trainer
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter tabsContainer flexStart bgTransParent tmeTabs mt30">
      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        <TabList>
          <Tab>TME Members</Tab>
          <Tab>Non TME Members</Tab>
          <Tab>Active Members</Tab>
          <Tab>Expired Members</Tab>
          <Tab>TME Analysis (Beta)</Tab>
        </TabList>

        <TabPanel>
          <div
            className="common-table-container tb-bordered mt15 hideMobile"
            ref={tableRef}
          >
            <CommonTable
              tableData={tmeSorting.sortedData}
              tablePagination={allDatas.pagination}
              tableColumns={tmeTbColumns}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={tmeLoading}
            />
          </div>

          {tmeLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              {/* <div
                className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30"
                ref={tableRef}
              >
                <PaymentLinkTable
                  tableData={allDatas.allSubmissions}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div> */}

              <div
                className="lead-logs-card-container only-mobile"
                ref={mobileTableRef}
              >
                <TMELogsMobile
                  tableData={allDatas.allSubmissions}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  loading={loading}
                  handleDelete={handleDelete}
                  setClickValues={setClickValues}
                  userInfoData={userInfoData}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div>
            </>
          )}
        </TabPanel>

        <TabPanel>
          <div className="common-table-container tb-bordered mt15 hideMobile">
            <CommonTable
              tableData={nonTMESorting.sortedData}
              tablePagination={allDatas.allCheckedInMembersPagination}
              tableColumns={nonTMETbColumns}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={checkedInMembersLoading}
            />
          </div>

          {checkedInMembersLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              {/* <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
                <PaymentLinkTable
                  tableData={allDatas.allCheckedInMembers}
                  tableColumns={tbColumns1}
                  tablePagination={allDatas.allCheckedInMembersPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div> */}

              <div className="lead-logs-card-container only-mobile">
                <CheckedinMembersMobile
                  tableData={allDatas.allCheckedInMembers}
                  tablePagination={allDatas.allCheckedInMembersPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  loading={loading}
                  setClickValues={setClickValues}
                  userInfoData={userInfoData}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div>
            </>
          )}
        </TabPanel>

        <TabPanel>
          <div className="common-table-container tb-bordered mt15 hideMobile">
            <CommonTable
              tableData={activeMembersSorting.sortedData}
              tablePagination={allDatas.allActiveUsersPagination}
              tableColumns={activeMembersTbColumns}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={tmeActiveUsersLoading}
            />
          </div>

          <>
            {/* <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
              <PaymentLinkTable
                tableData={allDatas.allActiveUsers}
                tableColumns={tbColumns2}
                tablePagination={allDatas.allActiveUsersPagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div> */}

            <div className="lead-logs-card-container only-mobile">
              {tmeActiveUsersLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <CheckedinMembersMobile
                  tableData={allDatas.allActiveUsers}
                  tablePagination={allDatas.allActiveUsersPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  loading={loading}
                  setClickValues={setClickValues}
                  userInfoData={userInfoData}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>
          </>
        </TabPanel>

        <TabPanel>
          <div className="common-table-container tb-bordered mt15 hideMobile">
            <CommonTable
              tableData={expiredMembersSorting.sortedData}
              tablePagination={allDatas.allExpiredMembersPagination}
              tableColumns={expiredMembersTbColumns}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isLoading={tmeExpiredMembersLoading}
            />
          </div>

          {tmeExpiredMembersLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              {/* <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
                <PaymentLinkTable
                  tableData={allDatas.allExpiredMembers}
                  tableColumns={tbColumns3}
                  tablePagination={allDatas.allExpiredMembersPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div> */}

              <div className="lead-logs-card-container only-mobile">
                <CheckedinMembersMobile
                  tableData={allDatas.allExpiredMembers}
                  tablePagination={allDatas.allExpiredMembersPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  loading={loading}
                  setClickValues={setClickValues}
                  userInfoData={userInfoData}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div>
            </>
          )}
        </TabPanel>

        <TabPanel>
          <TMEAnalysis
            userInfoData={userInfoData}
            allFilters={allFilters}
            setClickValues={setClickValues}
          />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default TMEtabs;
